import React from 'react';
import PropTypes from 'prop-types';

import PlayersListSeparator from './PlayersListSeparator';
import PlayerComponent from './PlayerComponent';
import {PlayerMinimalPropType} from "../../../../utils/propTypes";

const PlayerListSection = ({title, players, leftIcon, selectPlayer, extraClasses, titleBarRightIcon,
    onRightIconClick}) => (
        <div>
            <PlayersListSeparator
                extraClasses={extraClasses}
                title={title}
                rightIcon={titleBarRightIcon}
                onRightIconClick={onRightIconClick}
            />
            {players.map(p => (
                <PlayerComponent
                    key={p.id}
                    player={p}
                    selectPlayer={selectPlayer}
                    leftIcon={leftIcon}
                />
            ))}
        </div>
);

PlayerListSection.propTypes = {
    title: PropTypes.string.isRequired,
    leftIcon: PropTypes.string,
    selectPlayer: PropTypes.func.isRequired,
    extraClasses: PropTypes.string,
    players: PropTypes.arrayOf(PlayerMinimalPropType),
    titleBarRightIcon: PropTypes.string,
    onRightIconClick: PropTypes.func,

};

export default PlayerListSection;



// WEBPACK FOOTER //
// ./src/apps/create_game/components/Player/PlayersListSection.js